"use strict";

/**
 * @module Features.Security
 */
var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MatchesSessionPropertyValidationImpl = void 0;
var session_property_validation_1 = require("./../../features/security/session-property-validation");
var security_1 = require("../../../features/security");
/**
 * Implementation of {@link MatchesSessionPropertyValidation}
 *
 * @inheritdoc
 */
var MatchesSessionPropertyValidationImpl = /** @class */function (_super) {
  __extends(MatchesSessionPropertyValidationImpl, _super);
  /**
   * Create a MatchesSessionPropertyValidationImpl instance
   *
   * @param  regex   the regular expression
   */
  function MatchesSessionPropertyValidationImpl(regex) {
    var _this = _super.call(this, security_1.ValidationType.REGEX) || this;
    _this.regex = regex;
    return _this;
  }
  /**
   * Convert object to string
   *
   * @return a string representation of the MatchesSessionPropertyValidationImpl
   */
  MatchesSessionPropertyValidationImpl.prototype.toString = function () {
    return "SessionPropertyValidation [type=" + this.type + ", regex=" + this.regex + "]";
  };
  return MatchesSessionPropertyValidationImpl;
}(session_property_validation_1.SessionPropertyValidationImpl);
exports.MatchesSessionPropertyValidationImpl = MatchesSessionPropertyValidationImpl;